import React, { useState, useEffect } from "react";
import Navigation from "../components/Navigation";
import RegistarPedido from "../components/forms/RegistarPedido";
import useAxios from "../helpers/useAxios";
import { useKeycloak } from "@react-keycloak/web";

const Pedido = () => {
  const { keycloak } = useKeycloak();

  const { fetch, data, error, loaded } = useAxios("", "", {}, true);

  const onSubmitPedido = dataForm => {
    fetch("POST", "/User/create-ticket", {
      Name: keycloak.tokenParsed.given_name + " " + keycloak.tokenParsed.family_name,
      Email: keycloak.tokenParsed.email,
      nif: keycloak.tokenParsed.preferred_username,
      Subject: dataForm.assunto,
      Description: dataForm.descritivo,
      Type: 2,
    });
  }

  return (
    <div className="container-fluid mt-4 mb-3">
      <div className="row gx-3"  style={{justifyContent: 'space-around'}}>
        <div className="col-md-2" style={{maxWidth:'250px'}}>
          <Navigation activeKey="/registarpedido" />
        </div>
        <div className="col-md-10">
          <h1 className="mt-4">Suporte</h1>
          <h2 className="mb-4">Registar pedido</h2>
          <RegistarPedido onSubmitHandler={onSubmitPedido} />
        </div>
      </div>
    </div>
  );
};

export default Pedido;
